// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── RbacGate — Access Denied page ──────────────────────── */

.rg-denied {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
  padding: 48px 24px;
  text-align: center;
  animation: rg-fade-in 0.2s ease;
}

@keyframes rg-fade-in {
  from { opacity: 0; transform: translateY(10px); }
  to   { opacity: 1; transform: translateY(0); }
}

/* ── Lock icon ───────────────────────────────────────────── */
.rg-lock-icon {
  width: 56px;
  height: 56px;
  color: #8898aa;
  margin-bottom: 20px;
  flex-shrink: 0;
}

/* ── Title ───────────────────────────────────────────────── */
.rg-denied-title {
  font-size: 22px;
  font-weight: 700;
  color: #0b1f3b;
  margin: 0 0 12px;
  line-height: 1.3;
}

/* ── Body copy ───────────────────────────────────────────── */
.rg-denied-body {
  font-size: 14px;
  line-height: 1.65;
  color: #4a5568;
  margin: 0 0 28px;
  max-width: 380px;
}

/* ── Back button ─────────────────────────────────────────── */
.rg-denied-btn {
  padding: 11px 28px;
  border-radius: 10px;
  border: none;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  background: #1662e8;
  color: #ffffff;
  transition: opacity 0.15s, transform 0.1s;
}

.rg-denied-btn:hover {
  opacity: 0.88;
}

.rg-denied-btn:active {
  transform: scale(0.97);
}

/* ── Loading state (location-switch transition) ──────────── */
.rg-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
}

.rg-spinner {
  width: 40px;
  height: 40px;
  border: 3px solid rgba(22, 98, 232, 0.18);
  border-top-color: #1662e8;
  border-radius: 50%;
  animation: rg-spin 0.7s linear infinite;
}

@keyframes rg-spin {
  to { transform: rotate(360deg); }
}

.dark .rg-spinner,
[data-theme="dark"] .rg-spinner {
  border-color: rgba(100, 160, 255, 0.18);
  border-top-color: #64a0ff;
}

/* ── Dark-mode variants ──────────────────────────────────── */
.dark .rg-denied-title,
[data-theme="dark"] .rg-denied-title {
  color: #e8edf5;
}

.dark .rg-denied-body,
[data-theme="dark"] .rg-denied-body {
  color: #9babc2;
}

.dark .rg-lock-icon,
[data-theme="dark"] .rg-lock-icon {
  color: #5a6a85;
}
`, "",{"version":3,"sources":["webpack://./client/src/components/RbacGate/index.css"],"names":[],"mappings":"AAAA,8DAA8D;;AAE9D;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA,+DAA+D;AAC/D;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,cAAc;AAChB;;AAEA,+DAA+D;AAC/D;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,+DAA+D;AAC/D;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,+DAA+D;AAC/D;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;AACxB;;AAEA,+DAA+D;AAC/D;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yCAAyC;EACzC,yBAAyB;EACzB,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;;EAEE,uCAAuC;EACvC,yBAAyB;AAC3B;;AAEA,+DAA+D;AAC/D;;EAEE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB","sourcesContent":["/* ── RbacGate — Access Denied page ──────────────────────── */\n\n.rg-denied {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 60vh;\n  padding: 48px 24px;\n  text-align: center;\n  animation: rg-fade-in 0.2s ease;\n}\n\n@keyframes rg-fade-in {\n  from { opacity: 0; transform: translateY(10px); }\n  to   { opacity: 1; transform: translateY(0); }\n}\n\n/* ── Lock icon ───────────────────────────────────────────── */\n.rg-lock-icon {\n  width: 56px;\n  height: 56px;\n  color: #8898aa;\n  margin-bottom: 20px;\n  flex-shrink: 0;\n}\n\n/* ── Title ───────────────────────────────────────────────── */\n.rg-denied-title {\n  font-size: 22px;\n  font-weight: 700;\n  color: #0b1f3b;\n  margin: 0 0 12px;\n  line-height: 1.3;\n}\n\n/* ── Body copy ───────────────────────────────────────────── */\n.rg-denied-body {\n  font-size: 14px;\n  line-height: 1.65;\n  color: #4a5568;\n  margin: 0 0 28px;\n  max-width: 380px;\n}\n\n/* ── Back button ─────────────────────────────────────────── */\n.rg-denied-btn {\n  padding: 11px 28px;\n  border-radius: 10px;\n  border: none;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  background: #1662e8;\n  color: #ffffff;\n  transition: opacity 0.15s, transform 0.1s;\n}\n\n.rg-denied-btn:hover {\n  opacity: 0.88;\n}\n\n.rg-denied-btn:active {\n  transform: scale(0.97);\n}\n\n/* ── Loading state (location-switch transition) ──────────── */\n.rg-loading {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 60vh;\n}\n\n.rg-spinner {\n  width: 40px;\n  height: 40px;\n  border: 3px solid rgba(22, 98, 232, 0.18);\n  border-top-color: #1662e8;\n  border-radius: 50%;\n  animation: rg-spin 0.7s linear infinite;\n}\n\n@keyframes rg-spin {\n  to { transform: rotate(360deg); }\n}\n\n.dark .rg-spinner,\n[data-theme=\"dark\"] .rg-spinner {\n  border-color: rgba(100, 160, 255, 0.18);\n  border-top-color: #64a0ff;\n}\n\n/* ── Dark-mode variants ──────────────────────────────────── */\n.dark .rg-denied-title,\n[data-theme=\"dark\"] .rg-denied-title {\n  color: #e8edf5;\n}\n\n.dark .rg-denied-body,\n[data-theme=\"dark\"] .rg-denied-body {\n  color: #9babc2;\n}\n\n.dark .rg-lock-icon,\n[data-theme=\"dark\"] .rg-lock-icon {\n  color: #5a6a85;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
